{
    "ENV": {
        "TITLE": "Mijn Groene Knip | Staging",
        "API": "https://staging.api.mijngroeneknip.nl",
        "WEBSOCKET": "",
        "QR_LOGIN": "",
        "QR_LOGIN_REFRESH_RATE": "",
        "QR_LOGIN_CHECK_RATE": "",
        "MSAL_CLIENT_ID": "",
        "MSAL_TENANT_ID": "",
        "MSAL_AUTHORITY": "",
        "MSAL_KNOWN_AUTHORITIES": "",
        "HAS_VIDEO": "",
        "MAP_KEY": "",
        "MAP_ID": "",
        "DEBUG": ""
    }
}